import _ from 'lodash';
import moment from 'moment';
import XLSX_STYLE from 'xlsx-js-style';
import ExportExcelTemplate from './ExportDrawdownExcelTemplate';

export default {
    methods: {
        async onExport(data, typ) {
            const wb = XLSX_STYLE.utils.book_new();
            const ws = this.getExcelSheet(data);

            const TYP_TEXT = typ === 'amortization' ? '平均攤還' : '循環額度一次還本';
            XLSX_STYLE.utils.book_append_sheet(wb, ws, '動撥明細');
            XLSX_STYLE.writeFile(wb, `${this.detail.title}-${TYP_TEXT}-動撥明細-${moment().format('YYYYMMDD')}.xlsx`);
        },
        getExportDataRows(deatils) {
            return _.map(deatils, (o, i) => ({
                A: i + 1,
                B: o.repaymentWay === 1 ? '循環額度一次還本' : '平均攤還',
                C: o.drawdownDate ? moment(o.drawdownDate).format('YYYY-MM-DD') : '---',
                D: o.amount,
                E: o.feE_CD_AMT,
                F: o.feE_HAND_AMT,
                G: this.getTotalRealRePayedAmt(o),
                H: this.getPercentage(o),
                I: o.depositorBankName,
            }));
        },
        getExcelSheet(deatils) {
            const DATA = this.getExportDataRows(deatils);

            const sheet = _.cloneDeep(ExportExcelTemplate);

            XLSX_STYLE.utils.sheet_add_json(sheet, DATA, { skipHeader: true, origin: 'A2' });

            const widthSettings = [4, 17, 10, 15, 10, 8, 15, 10, 15];
            sheet['!cols'] = _.map(widthSettings, (h) => ({ wch: h }));

            _.forEach(sheet, (value, key) => {
                if (!key.includes('!')) {
                    const COL = key.substring(0, 1);

                    if (sheet[key].s) {
                        sheet[key].s.border = {
                            bottom: { style: 'thin', color: 'FFFFFFFF' },
                            top: { style: 'thin', color: 'FFFFFFFF' },
                            left: { style: 'thin', color: 'FFFFFFFF' },
                            right: { style: 'thin', color: 'FFFFFFFF' },
                        };
                    } else {
                        sheet[key].s = {
                            border: {
                                bottom: { style: 'thin', color: 'FFFFFFFF' },
                                top: { style: 'thin', color: 'FFFFFFFF' },
                                left: { style: 'thin', color: 'FFFFFFFF' },
                                right: { style: 'thin', color: 'FFFFFFFF' },
                            },
                        };
                    }

                    if (COL === 'A' || COL === 'B' || COL === 'C' || COL === 'I') sheet[key].s.alignment = { horizontal: 'left' };
                    else sheet[key].s.alignment = { horizontal: 'right' };

                    // 設定金額格式
                    if (COL === 'D' || COL === 'E' || COL === 'F' || COL === 'G') sheet[key].z = '#,##0_-;-#,##0_-;0;General';
                }
            });

            return sheet;
        },

        getTotalRealRePayedAmt(row) {
            return _.chain(row.repaymentList)
                .filter((o) => o.repaymentDate <= +new Date())
                .sumBy('principalAmount')
                .value();
        },
        getPercentage(row) {
            return `${Math.round(((this.getTotalRealRePayedAmt(row) / row.amount) * 1000) / 10)}%`;
        },
    },
};
